import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout, selectUser } from './features/userSlice'; // Ensure userSlice.js exists
import { auth } from './firebase'; // Import Firebase auth
import Homescreen from './screens/Homescreen.js';
import Loginscreen from './screens/Loginscreen.js';

import ProfileScreen from './screens/ProfileScreen.js';

import './App.css';

function App() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser); // Get user from Redux

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        dispatch(
          login({
            uid: userAuth.uid,
            email: userAuth.email,
          })
        );
      } else {
        dispatch(logout()); // Call logout as a function
      }
    });

    return unsubscribe; // Cleanup function to avoid memory leaks
  }, [dispatch]); // Dependency array to prevent infinite loops

  return (
    <div className="app">
      <Router>
        {!user ? (
          <Loginscreen />
        ) : (
          <Routes>
            <Route path="/" element={<Homescreen />} />
            <Route path='/profile' element= {<ProfileScreen />}>
            
            </Route>
          </Routes>
        )}
      </Router>
    </div>
  );
}

export default App;
